import { isClient } from "common/helper";
import { cleanEnv, str } from "envalid";

export const envConfig = cleanEnv(process.env, {
  REACT_APP_ENV: str(),
  REACT_APP_VERSION: str({ default: "0.0.0.0" }),
  REACT_APP_DEFAULT_LANG: str({ default: "th" }),
  NODE_ENV: str({ default: "development" }),
  SYNC_FUSION_LICENSE_KEY: str({
    default:
      "ORg4AjUWIQA/Gnt2UlhhQlVMfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX5adEFjWnpedXVTQ2NZ",
  }),
});

// ใช้แค่ tag สภาพแวดล้อมใน Sidebar (ENV_TAGS) — มาจาก REACT_APP_ENV ที่ set ตอน build
// (Dockerfile ARG/docker-compose) ไม่เกี่ยวกับ window.__ENV__ ด้านล่าง ไม่ต้อง match host เอง
// อีกต่อไปเพราะ REACT_APP_ENV ระบุ environment ตรงๆ อยู่แล้ว
export const nodeEnv = envConfig.REACT_APP_ENV;

// window.__ENV__ inject โดย NestJS server ตอน runtime ผ่าน GET /backoffice/env.js
// (ดู flex2-api-nest/src/app.controller.ts) เป็นแหล่งเดียวของค่าทั้งหมดใน env นี้แล้ว
// (HOST, API, API_ENDPOINT, BACKOFFICE_ENDPOINT, APP_ENDPOINT, MARKETPLACE_ENDPOINT,
// REACT_APP_MSAL_*) ไม่มี hardcoded per-host map อีกต่อไป — เปลี่ยน host/ค่าพวกนี้ตอน deploy
// ได้จากฝั่ง api อย่างเดียวโดยไม่ต้อง rebuild frontend
const env = isClient ? window.__ENV__ : undefined;

console.log("ENV : ", env);
export default env;
